import React from 'react'
import line from '../../Assets/icons/line.svg'
import check_out from '../../Assets/our_services/1.svg'
import Products from '../../Data/Products'

function WhatWeOffer() {
    return (
        <div className="w-full bg-white">
            <div className="sectionlayout lato z-10 relative pt-[6rem]" >
                <div className='absolute right-[1rem] md:right-[2rem] -top-[5rem]'>
                    <img src={check_out} alt="" className='h-[12rem] md:h-[15rem]' />
                </div>
                <div className='text-center p-4 md:p-8'>
                    <div className='flex items-center justify-center pt-[6rem] md:pt-[3rem]'>
                        <img src={line} alt="" className="h-1 w-full max-w-[100px] md:max-w-[150px]" />
                        <p style={{ fontSize: 'clamp(17px,1.2vw,20px)' }} className='uppercase text-[#463820] opacity-[63%] font-semibold w-[20rem]'>What We Offer</p>
                        <img src={line} alt="" className="h-1 w-full max-w-[100px] md:max-w-[150px]" />
                    </div>
                    <div className='mt-4'>
                        <p style={{ fontSize: 'clamp(24px,4vw,46px)' }} className='uppercase text-[#C9AA5D] w-[90%] md:w-[80%] mx-auto font-extrabold'>OUR SERVICES</p>
                    </div>
                    <div className='mt-4'>
                        <p style={{ fontSize: 'clamp(16px,2.5vw,28px)' }} className='text-[#726652] w-[90%] md:w-[80%] mx-auto font-medium leading-[1.5] md:leading-[1.75]'>
                            Contemporary, rustic, elegant, or whimsical—whatever your artistic vision may be, we have the medium to bring it to life. We carry only the finest natural stone and tile lines, each with a character all its own.
                        </p>
                    </div>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-8 gap-5 md:gap-8 mb-16'>
                    {Products.map((card, index) => (
                        <a href={card.link} target="_blank" rel="noopener noreferrer">
                            <div key={index} className='px-4 md:px-8 py-16 rounded-xl drop-shadow-lg bg-[#D4D4D4] cursor-pointer' >
                                <div className='flex items-center justify-center pt-2'>
                                    <img src={card.img} alt="" className='h-[150px] md:h-[220px]' />
                                </div>
                                <p style={{ fontSize: 'clamp(20px,2vw,32px)' }} className='font-extrabold text-[#987423] text-center mt-5 mb-2'>{card.title}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default WhatWeOffer
